import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

import { computed } from "vue";
import { ArtifactNameDisplayProps } from "@/types";
import { timStore, useScreen } from "@/hooks";
import { FlexBox, Typography, AttributeChip } from "@/components/common";


/**
 * Displays the name, code path, and type of an artifact.
 */
const __default__ = {
  name: "ArtifactNameDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifact: {},
    displayType: { type: Boolean },
    displayTooltip: { type: Boolean },
    isHeader: { type: Boolean },
    dense: { type: Boolean },
    dataCyName: {},
    dataCyType: {},
    align: {}
  },
  setup(__props: any) {

const props = __props;

const { smallWindow } = useScreen();

const artifactType = computed(() => timStore.getTypeName(props.artifact.type));

const hasCodePath = computed(
  () => props.artifact.name.includes("/") && !props.artifact.name.includes(" ")
);
const hasSymbolName = computed(
  () => props.artifact.name.includes("#") && props.artifact.name.includes("<")
);
const splitLines = computed(() => props.artifact.isCode || hasCodePath.value);

const codePath = computed(() =>
  splitLines.value
    ? props.artifact.name.split("/").slice(0, -1).join("/") + "/"
    : undefined
);

const codePathClass = computed(
  () => "full-width " + (props.dense ? "text-no-wrap" : "text-word-break-all")
);

const fileName = computed(() =>
  splitLines.value
    ? props.artifact.name.split("/").pop()?.split("#")[0]
    : props.artifact.name
);

const symbolName = computed(() =>
  hasSymbolName.value ? props.artifact.name.split("#").pop()?.split("<")[0] : ""
);

const symbolFileLines = computed(() =>
  hasSymbolName.value
    ? `<${props.artifact.name.split("<").pop()?.split(">")[0]}>`
    : ""
);

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_unref(FlexBox), {
    align: _unref(smallWindow) ? 'start' : 'center',
    justify: "between",
    class: "overflow-hidden",
    column: _unref(smallWindow),
    style: _normalizeStyle(_unref(smallWindow) ? 'flex-direction: column-reverse' : undefined)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), {
        column: "",
        "full-width": ""
      }, {
        default: _withCtx(() => [
          (splitLines.value)
            ? (_openBlock(), _createBlock(_unref(Typography), {
                key: 0,
                variant: "caption",
                value: codePath.value,
                ellipsis: "",
                align: props.align,
                class: _normalizeClass(codePathClass.value)
              }, null, 8, ["value", "align", "class"]))
            : _createCommentVNode("", true),
          (symbolName.value)
            ? (_openBlock(), _createBlock(_unref(Typography), {
                key: 1,
                variant: "caption",
                value: fileName.value + symbolFileLines.value,
                ellipsis: "",
                align: props.align,
                class: _normalizeClass(codePathClass.value)
              }, null, 8, ["value", "align", "class"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(Typography), {
            align: props.align,
            class: _normalizeClass(splitLines.value ? 'full-width text-word-break-all' : 'full-width'),
            el: props.isHeader ? 'h1' : undefined,
            variant: props.isHeader ? 'subtitle' : undefined,
            value: symbolName.value || fileName.value,
            ellipsis: "",
            color: "text",
            "data-cy": props.dataCyName
          }, null, 8, ["align", "class", "el", "variant", "value", "data-cy"]),
          (props.displayTooltip)
            ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 2 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.artifact.name), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (props.displayType)
        ? (_openBlock(), _createBlock(_unref(AttributeChip), {
            key: 0,
            "artifact-type": "",
            value: artifactType.value,
            "data-cy": props.dataCyType
          }, null, 8, ["value", "data-cy"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["align", "column", "style"]))
}
}

})